// Copyright (c) 2021-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { ReactNode, useRef, useState } from "react";
import { MAIN_LAYOUT_CLASS_NAME } from "../../../../core/constants/className";
import { AppHeader } from "../../common/appHeader/AppHeader";
import { AppFooter } from "../../common/appFooter/AppFooter";
import { Theme } from "../../../../../../io/hyperify/core/types/Theme";
import { useScrollTop } from "../../../../../../io/hyperify/frontend/hooks/useScrollTop";
import { useScrollingElement } from "../../../../../../io/hyperify/frontend/hooks/useScrollingElement";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./MainLayout.scss";

export interface MainLayoutProps {
    readonly t: TranslationFunction;
    readonly children: ReactNode;
    readonly className?: string;
    readonly theme?: Theme;
    readonly setThemeDark?: boolean;
}

export function MainLayout (props: MainLayoutProps) {
    const t = props?.t;
    const [ theme, setTheme ] = useState<Theme>(props?.theme ?? Theme.LIGHT);
    const isThemeDark = theme === Theme.DARK;
    const myRef = useRef<HTMLDivElement>(null);
    const scrollingElement = useScrollingElement();
    const scrollTop = useScrollTop(scrollingElement);
    const isOnTop : boolean = scrollTop === 0;
    // const statistics = useStoreStatistics();
    // const invoiceSum : number = isNumber(statistics?.invoiceSum) ? statistics?.invoiceSum : 0;
    // const translationParams = {
    //     YEARS: COMPANY_ACTIVE_YEARS,
    //     CLIENT_COUNT          : statistics?.clients  ?? 0,
    //     INVOICE_COUNT         : statistics?.invoices ?? 0,
    //     PAYMENT_COUNT         : statistics?.payments ?? 0,
    //     BUSINESS_CLIENT_COUNT : statistics?.businessClients ?? 0,
    //     PERSONAL_CLIENT_COUNT : statistics?.personalClients ?? 0,
    //     INVOICE_SUM           : invoiceSum.toFixed(0),
    // };
    return (
        <div
            ref={myRef}
            className={MAIN_LAYOUT_CLASS_NAME}
            data-theme={isThemeDark ? "dark" : "light"}
        >
            {/*<SEOContainer*/}
            {/*    path={INDEX_ROUTE}*/}
            {/*    title={t(T_ABOUT_TITLE, translationParams)}*/}
            {/*    description={t(T_ABOUT_DESCRIPTION, translationParams)}*/}
            {/*    siteName={t(T_SITE_NAME)}*/}
            {/*/>*/}
            <div className={`${MAIN_LAYOUT_CLASS_NAME}-header`}>
                <AppHeader
                    className={`${MAIN_LAYOUT_CLASS_NAME}-header`}
                    theme={theme}
                    changeTheme={setTheme}
                    t={t}
                    isFixed={!isOnTop}
                />
            </div>

            <section className={`${MAIN_LAYOUT_CLASS_NAME}-content`}>
                {props.children}
            </section>

            <AppFooter
                className={`${MAIN_LAYOUT_CLASS_NAME}-footer`}
                t={t}
            />

        </div>
    );
}
